import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import Spinner from "../../Components/spinner/spinner";
import { useState } from "react";
import useInventoryManagement from "./hooks/useInventoryManagement";

const AddInventory = () => {
    const navigate = useNavigate();

    const {
        spinner,
        inventoryFormData,
        inventoryFormik,
        categoryFullList,
        vendorFullList,
        handleInventoryChange
    } = useInventoryManagement()

    const units = [
        { value: 'Strip', label: 'Strip' },
        { value: 'Bottle', label: 'Bottle' },
        { value: 'Box', label: 'Box' },
        { value: 'Pack', label: 'Pack' },
        { value: 'Other', label: 'Other' },
    ]

    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner && <Spinner />}
                <header>
                    <h2 className='page-tittle'>
                        <i
                            className="fa-solid fa-angle-left cusgap cursor"
                            onClick={() => { navigate(-1) }}
                        ></i>
                         Inventory Management
                    </h2>
                    <hr />
                </header>

                <form className="row ps-4 cus-form mt-4" onSubmit={inventoryFormik.handleSubmit}>
                    <div className="py-3 mb-3 rounded row">

                        {/* Product Name */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Product Name *</label>
                            <input
                                type="text"
                                name="productName"
                                className={`form-control alreadytext ${inventoryFormik.touched.productName && inventoryFormik.errors.productName ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.productName}
                            />
                            {inventoryFormik.touched.productName && inventoryFormik.errors.productName && (
                                <div className="invalid-feedback">{inventoryFormik.errors.productName}</div>
                            )}
                        </div>

                        {/* Category */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Category *</label>
                            <select className={`form-select form-control ${inventoryFormik.touched.category && inventoryFormik.errors.category ? 'is-invalid' : ''}`} aria-label="Default select example" name="category" onChange={handleInventoryChange} value={inventoryFormData.category}>
                                <option value='' hidden>Select Category</option>
                                {categoryFullList.map((item) => (
                                    <option value={item._id} key={item._id}
                                    >{item?.name}</option>
                                ))}
                            </select>
                            {inventoryFormik.touched.category && inventoryFormik.errors.category && (
                                <div className="invalid-feedback">{inventoryFormik.errors.category}</div>
                            )}
                        </div>

                        {/* expire date */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Expire Date *</label>
                            <input
                                type="date"
                                name="expireDate"
                                className={`form-control alreadytext ${inventoryFormik.touched.expireDate && inventoryFormik.errors.expireDate ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.expireDate}
                            />
                            {inventoryFormik.touched.expireDate && inventoryFormik.errors.expireDate && (
                                <div className="invalid-feedback">{inventoryFormik.errors.expireDate}</div>
                            )}
                        </div>

                        {/* unit */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Unit *</label>

                            <select className={`form-select form-control ${inventoryFormik.touched.unit && inventoryFormik.errors.unit ? 'is-invalid' : ''}`} aria-label="Default select example" name="unit" onChange={handleInventoryChange} value={inventoryFormData.unit}>
                                <option value='' hidden>Select Unit</option>
                                {units.map((item) => (
                                    <option value={item.value} key={item.value}
                                    >{item?.label}</option>
                                ))}
                            </select>
                            {inventoryFormik.touched.unit && inventoryFormik.errors.unit && (
                                <div className="invalid-feedback">{inventoryFormik.errors.unit}</div>
                            )}
                        </div>

                        {/* Brand/Manufacture */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Brand/Manufacture *</label>
                            <input
                                type="text"
                                name="brand"
                                className={`form-control alreadytext ${inventoryFormik.touched.brand && inventoryFormik.errors.brand ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.brand}
                            />
                            {inventoryFormik.touched.brand && inventoryFormik.errors.brand && (
                                <div className="invalid-feedback">{inventoryFormik.errors.brand}</div>
                            )}
                        </div>

                        {/* Stock Quantity */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Stock Quantity *</label>
                            <input
                                type="number"
                                name="stockQuantity"
                                className={`form-control alreadytext ${inventoryFormik.touched.stockQuantity && inventoryFormik.errors.stockQuantity ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.stockQuantity}
                            />
                            {inventoryFormik.touched.stockQuantity && inventoryFormik.errors.stockQuantity && (
                                <div className="invalid-feedback">{inventoryFormik.errors.stockQuantity}</div>
                            )}
                        </div>

                        {/* MRP */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">MRP *</label>
                            <input
                                type="number"
                                name="mrp"
                                className={`form-control alreadytext ${inventoryFormik.touched.mrp && inventoryFormik.errors.mrp ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.mrp}
                            />
                            {inventoryFormik.touched.mrp && inventoryFormik.errors.mrp && (
                                <div className="invalid-feedback">{inventoryFormik.errors.mrp}</div>
                            )}
                        </div>

                        {/* Re-order Level */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Re-order Level *</label>
                            <input
                                type="number"
                                name="reorderLevel"
                                className={`form-control alreadytext ${inventoryFormik.touched.reorderLevel && inventoryFormik.errors.reorderLevel ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.reorderLevel}
                            />
                            {inventoryFormik.touched.reorderLevel && inventoryFormik.errors.reorderLevel && (
                                <div className="invalid-feedback">{inventoryFormik.errors.reorderLevel}</div>
                            )}
                        </div>

                        {/* Purchase Price */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Purchase Price *</label>
                            <input
                                type="number"
                                name="purchasePrice"
                                className={`form-control alreadytext ${inventoryFormik.touched.purchasePrice && inventoryFormik.errors.purchasePrice ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.purchasePrice}
                            />
                            {inventoryFormik.touched.purchasePrice && inventoryFormik.errors.purchasePrice && (
                                <div className="invalid-feedback">{inventoryFormik.errors.purchasePrice}</div>
                            )}
                        </div>

                        {/* Vendor */}
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Vendor *</label>
                            {/* <input
                                type="text"
                                name="vendor"
                                className={`form-control alreadytext ${inventoryFormik.touched.vendor && inventoryFormik.errors.vendor ? 'is-invalid' : ''
                                    }`}
                                onChange={handleInventoryChange}

                                value={inventoryFormData.vendor}
                            /> */}
                            <select className={`form-select form-control ${inventoryFormik.touched.vendor && inventoryFormik.errors.vendor ? 'is-invalid' : ''}`} aria-label="Default select example" name="vendor" onChange={handleInventoryChange} value={inventoryFormData.vendor}>
                                <option value='' hidden>Select Category</option>
                                {vendorFullList.map((item) => (
                                    <option value={item._id} key={item._id}
                                    >{item?.name}</option>
                                ))}
                            </select>
                            {inventoryFormik.touched.vendor && inventoryFormik.errors.vendor && (
                                <div className="invalid-feedback">{inventoryFormik.errors.vendor}</div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end" style={{ paddingRight: "50px" }}>
                        <button
                            type="submit"
                            className="btn yesbtn w-25"
                            disabled={inventoryFormik.isSubmitting}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default AddInventory;